import { FieldValidation, FormValidation } from '../types/form';
import { iodine, trybaPhoneMask, fieldWasUpdated, zipOrCityMask, verifyTrybaPhoneCapAdresse } from './validation';
import { AlpineComponent } from 'alpinejs';

export interface FormFieldValidationAlpine extends AlpineComponent<Record<string, any>> {
    [key: string]: any;
    errorMessages: { [key in string]: string }[];
    trybaPhoneLoading: boolean;
    validationError: boolean;
    zipOrCityMask: (input: string) => string;
    trybaPhoneMask: (input: string) => string;
    fieldWasUpdated: (element: HTMLElement) => boolean;
    validateField: (field: HTMLInputElement) => void;
    validateSelect: (field: HTMLSelectElement) => void;
    validateCheckbox: (field: HTMLInputElement) => void;
    verifyTrybaPhone: (phone: string, element: HTMLInputElement) => Promise<void>;
    handleError: (validation: FieldValidation, name: string) => void;
    displayErrors: (validation: FormValidation) => void;
    hideErrors: (validation: FormValidation) => void;
}

export function getFieldValidation(rules): FormFieldValidationAlpine {
    return {
        ...{
            zipOrCityMask,
            trybaPhoneMask,
            fieldWasUpdated,
        },
        errorMessages: [],
        trybaPhoneLoading: false,
        validationError: true,
        // Textarea chars counter
        nbOfChars: 0,
        MaxNbOfChars: 1500,
        // Chars max value
        maxCharsLastName: 150,
        maxCharsFirstName: 150,
        maxCharsEmail: 150,
        maxCharsAddress: 300,
        check: HTMLElement,
        // test
        firstnameLength: 0,
        validateLength(event: KeyboardEvent & { target: HTMLInputElement }) {
            this.nbInputs = event.target.value.length;
            this.nbOfChars = this.nbInputs
        },
        validateField(field: HTMLInputElement): void {
            const name = field.dataset.name as string;
            const validation = iodine.assert(
                field.value,
                rules[name],
            ) as FieldValidation;
            const parent = field.closest('.input-group');
            let check : HTMLElement | null = null;
            if (validation.valid) {
                if (parent) {
                    check = parent.querySelector('[js-check-validate]')
                } else {
                     check = field.parentElement ? field.parentElement?.querySelector('[js-check-validate]') : null;
                }
                if (check) {
                    check.classList.remove('opacity-0')
                }
            } else {
                if (parent) {
                    const closestInputGroup = field.closest('.input-group');
                    check = closestInputGroup ? closestInputGroup.querySelector('[js-check-validate]') : null;
                } else {
                    check = field.parentElement ? field.parentElement?.querySelector('[js-check-validate]') : null;
                }

                if (check) {
                    check.classList.add('opacity-0')
                }
            }
            this.handleError(validation, name);
        },
        // special function to validate ZIP just with a value defined in autocomplete results,
        validateZipField(field: HTMLInputElement): void {
            let validAdress = false;
            const allResult = this.results = JSON.parse(JSON.stringify(this.results));
            let check : HTMLElement | null | undefined = null;
            check = field?.parentElement?.parentElement?.querySelector('[js-check-validate]')
            // setTimeout because there is a delay between input.value and click at the autocomplete results which push result as input value
            setTimeout(() => {
                allResult.forEach(el => {
                    if (el.codesPostaux.length > 1)
                        el.codesPostaux.forEach(subEl => {
                            const result = subEl + ' ' + el.nom
                            if (field?.value == result) {
                                validAdress = true;
                            }
                        })
                    else {
                        const result = el.codesPostaux[0] + ' ' + el.nom
                        if (field?.value == result) {
                            validAdress = true;
                        }
                    }
                })
                if (validAdress) {
                    if (check) {
                        check.classList.remove('opacity-0')
                    }
                } else {
                    if (check) {
                        check.classList.add('opacity-0')
                    }
                    // set Manually the error message
                    this.errorMessages['zip'] = 'Veuillez saisir une adresse valide'
                }
            }, 600)
        },
        validateNotEmpty(field: HTMLInputElement): void {
            const name = field.dataset.name;
            const parent = field.closest('.input-group') ? field.closest('.input-group') : field.parentElement;
            let check : HTMLElement | null = null;
            let validation = {}
            if (field.value.length == 0) {
                validation = {
                    error: 'Ce champ est requis',
                    valid: false,
                }
                if (parent) {
                    check = parent.querySelector('[js-check-validate]');
                    check?.classList.add('opacity-0');
                }
            }  else {
                if (parent) {
                    check = parent.querySelector('[js-check-validate]');
                    check?.classList.remove('opacity-0');
                }
            }

            // @ts-ignore
            this.handleError(validation, name);
        },
        lengthLimit(maxLength: number, item: any, event: KeyboardEvent & { target: HTMLInputElement }) {
            let wrapper: any = null;
            if (item.parentElement.querySelector('#lengthControl')) {
                wrapper = item.parentElement.querySelector('#lengthControl')
            } else {
                wrapper = item.parentElement.parentElement.querySelector('#lengthControl')
            }
            if (event.target.value.length === maxLength) {
                if (wrapper?.classList.contains('text-secondary-02')) {
                    return;
                } else {
                    wrapper.classList.add('text-secondary-02')
                }
            } else {
                if (wrapper?.classList.contains('text-secondary-02')) {
                    wrapper.classList.remove('text-secondary-02')
                }
            }
            if (wrapper) {
                wrapper.innerHTML = event.target.value.length + '/' + maxLength
            }
        },
        validateSelect(field: HTMLSelectElement): void {
            const name = field.dataset.name;
            const validation = iodine.assert(
                field.selectedOptions[0].value,
                // @ts-ignore
                rules[name],
            ) as FieldValidation;
            // @ts-ignore
            this.handleError(validation, name);
        },
        validateCheckbox(field: HTMLInputElement): void {
            const name = (field.dataset.name as string).split('_')[0];
            const value = Array.from(document.querySelectorAll(`[name*=${name}][type=checkbox], [name*=${name}][type=radio]`))
                // @ts-ignore
                .map((i: HTMLInputElement) => i.checked)
                .reduce((a, b) => a || b, false);
            const validation = iodine.assert(value, rules[name]) as FieldValidation;
            this.handleError(validation, name);
        },
        allowPhoneValidationExternalForm() {
            this.validationError = false;
        },
        async verifyTrybaPhone(phone: string, element: HTMLInputElement): Promise<void> {
            this.trybaPhoneLoading = true;
            const valid = await verifyTrybaPhoneCapAdresse(phone, rules.phone);
            this.trybaPhoneLoading = false;
            if (!valid) {
                if (element && element.parentElement){
                   let checkValidateElement = element.parentElement.querySelector('[js-check-validate]');
                   if (!checkValidateElement && element.parentElement.parentElement) {
                       checkValidateElement = element.parentElement.parentElement.querySelector('[js-check-validate]')
                   }
                   checkValidateElement?.classList.add('opacity-0');
                }
                this.validationError = true
                this.displayErrors({ valid: false, fields: { phone: { error: "Le numéro n'est pas un numéro valide" } } });
            } else {
                this.validationError = false
                this.hideErrors({ valid: true, fields: { phone: { error: '' } } });
            }
        },
        handleError(validation: FieldValidation, name: string) {
            /*
             * if we have error displayed from the server validation, then
             * we delete it only when the field is updated
             */
            const serverErrorElement = document.querySelector<HTMLSpanElement>(`[data-error-server="${name}"`);
            if (serverErrorElement) {
                (serverErrorElement.parentNode as HTMLDivElement).remove();
            }
            if (validation.valid) {
                this.errorMessages[name] = '';
            } else {
                this.errorMessages[name] = validation.error;
            }
        },
        displayErrors(validation: FormValidation) {
            Object.keys(validation.fields).forEach((key: string) => {
                this.errorMessages[key] = validation.fields[key].error;
            });
        },
        hideErrors(validation: FormValidation) {
            Object.keys(validation.fields).forEach((key: string) => {
                delete this.errorMessages[key];
            });
        },
    };
}
